<template>
  <div>
    <div class="dataTables_info" role="status">
      {{ $t('pagination.total') }} {{ count }} {{ $t('pagination.records') }},
      {{ $t('pagination.showing') }} {{ from }} - {{ to }},
      <label for="field-show-rows">
        {{ $t('pagination.show-rows') }}:
        <select
            name="page-size-list"
            id="field-show-rows"
            v-model.number="page_size"
            @change="store_page_size"
        >
          <option value="50" selected>50</option>
          <option value="100">100</option>
          <option value="200">200</option>
        </select>
      </label>
    </div>

    <div class="dataTables_paginate paging_simple_numbers">
      <ul class="pagination">

        <li class="paginate_button page-item previous" :class="{'disabled': page === 1}">
          <a class="page-link" @click.prevent="$emit('paginate', format_msg(1))">
            <em class="fa fa-angle-double-left"></em>
          </a>
        </li>

        <li class="paginate_button page-item previous" :class="{'disabled': page === 1}">
          <a class="page-link" @click.prevent="$emit('paginate', format_msg(page-1))">
            <em class="fa fa-angle-left"></em>
          </a>
        </li>

        <li class="paginate_button page-item previous" v-for="p in prev_pages(page)" :key="p">
          <a class="page-link" @click="$emit('paginate', format_msg(p))">{{ p }}</a>
        </li>

        <li class="paginate_button page-item">
          <a class="page-link" @click="$emit('paginate', format_msg(page))">
            <b>{{ page }}</b>
          </a>
        </li>

        <li class="paginate_button page-item next" v-for="p in next_pages(page, pages)" :key="p">
          <a class="page-link" @click="$emit('paginate', format_msg(p))">{{ p }}</a>
        </li>

        <li class="paginate_button page-item next" :class="{'disabled': page === pages}">
          <a class="page-link" @click="$emit('paginate', format_msg(page+1))">
            <em class="fa fa-angle-right"></em>
          </a>
        </li>

        <li class="paginate_button page-item next" :class="{'disabled': page === pages}">
          <a class="page-link" @click="$emit('paginate', format_msg(pages))">
            <em class="fa fa-angle-double-right"></em>
          </a>
        </li>

      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    page: Number,
    pages: Number,
    count: Number,
    from: Number,
    to: Number
  },
  data: function() {
    return {
      page_size: process.env.DEFAULT_PAGE_SIZE
    }
  },
  methods: {
    prev_pages(page) {
      let data = []
      for (let i = page - 5; i < page; i++) {
        if (i > 0) {
          data.push(i)
        }
      }
      return data
    },
    next_pages(page, pages) {
      let data = []
      for (let i = page + 1; i <= page + 5; i++) {
        if (i <= pages) {
          data.push(i)
        }
      }
      return data
    },
    format_msg(p) {
      return {
        page: p,
        page_size: this.page_size
      }
    },
    store_page_size(e) {
      let page_size = Number.parseInt(e.target.value)

      this.$store.dispatch('setPageSize', {
        name: this.$route.name,
        page_size: page_size
      })
      this.$emit('paginate', {
        page: 1,
        page_size: page_size
      })
    }
  },
  mounted: function () {
    this.$i18n.locale = this.$store.getters.language
    let stored_page_size = this.$store.getters.page_size(this.$route.name)

    if (stored_page_size) {
      this.page_size = stored_page_size
    }
  },
}
</script>

<style scoped>
select {
  line-height: 12px;
  min-height: 32px;
  border: 1px solid #d9d5d5;
  border-radius: 0.25em;
  padding: 0.25em 0.5em;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue